





import Vue from 'vue'
import Mailing from '@/models/mailing/mailing'
import filtersList from '@/components/Newsletters/filtersList.vue'

export default Vue.extend({
  name: 'PatientIndexColumn',
  props: {
    row: Object as () => Mailing
  },
  components: {
    filtersList
  }
})
